import LanguageSelect from 'components/LanguageSelect/LanguageSelect';

export default LanguageSelect;
